import { map } from 'rxjs/operators';
import { ofType, combineEpics } from 'redux-observable';
// ---- external imports ----

import { loadingActions } from '~/store';
import { GAME_CREATED_NEW_START, GAME_CREATED_NEW_ENDED, GAME_CREATED_NEW } from '~/store/game/actionTypes';
// ---- internal imports ----


const startGameLoading = (action$) => action$.pipe(
	ofType(GAME_CREATED_NEW_START),
	map(() => loadingActions.start(GAME_CREATED_NEW))
);

const endGameLoading = (action$) => action$.pipe(
	ofType(GAME_CREATED_NEW_ENDED),
	map(() => loadingActions.end(GAME_CREATED_NEW))
);


export default combineEpics(
	startGameLoading,
	endGameLoading
);
